import React from "react";

// 🔹 Offer images
import offer1 from "../../Assets/4rth_slider/3094-bh (1).png";
import offer2 from "../../Assets/4rth_slider/3094-bh.png";
import offer3 from "../../Assets/4rth_slider/3096-eh (1).png";
import offer4 from "../../Assets/4rth_slider/5149-vk (1).png";
import offer5 from "../../Assets/4rth_slider/5149-vk.png";
import offer6 from "../../Assets/4rth_slider/5766-hz (1).png";
import offer7 from "../../Assets/4rth_slider/5766-hz.png";
import offer8 from "../../Assets/4rth_slider/3096-eh.png";
import Fifth_slider from "./Fifth_slider";

const offers = [
  offer1,
  offer2,
  offer3,
  offer4,
  offer5,
  offer6,
  offer7,
  offer8,
];

const Fourth_slider = () => {
  return (
    <>
    <div className="w-full bg-white py-10">
      <div className="max-w-7xl mx-auto px-4">
        
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-[26px] font-medium text-black">
            Exclusive Offers
          </h2>
          <p className="text-sm text-gray-400">
            Best way to save more
          </p>
        </div>

        {/* Responsive Offers Grid */}
        <div
          className="
            grid
            grid-cols-2
            sm:grid-cols-2
            md:grid-cols-3
            lg:grid-cols-4
            gap-4
          "
        >
          {offers.map((img, index) => (
            <div
              key={index}
              className="
                w-full
                h-[120px]
                sm:h-[130px]
                md:h-[140px]
                rounded-xl
                overflow-hidden
                cursor-pointer
                hover:scale-[1.03]
                transition-transform
                duration-300
              "
            >
              <img
                src={img}
                alt={`offer-${index}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

      </div>
    </div>
    {/* <Fifth_slider/> */}
    </>
  );
};

export default Fourth_slider;
